// extracted by mini-css-extract-plugin
module.exports = {"articleContent":"ArticleContent_articleContent___v7OD"};